<div class="nm" dir="rtl">
  <div #mapEl class="nm__map" dir="ltr" aria-label="מפת מודעות נדל״ן"></div>

  <!-- Top bar: count + close -->
  <div class="nm__top">
    @if (!failed) {
      <span class="nm__count" [class.is-loading]="loading">
        @if (loading) { <span class="nm__spinner"></span> טוען מפה… }
        @else if (pending > 0) { <span class="nm__spinner"></span> {{ totalPoints | number }} על המפה · ממקמים עוד נכסים… }
        @else { {{ totalPoints | number }} נכסים על המפה }
      </span>
    }
    <button type="button" class="nm__close" (click)="closed.emit()" [attr.aria-label]="closeLabel">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>
      <span>{{ closeLabel }}</span>
    </button>
  </div>

  <!-- Search in this area / active area -->
  @if (!failed) {
    <div class="nm__area">
      @if (movedByUser) {
        <button type="button" class="nm__area-btn" (click)="searchThisArea()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.5 14h-.8l-.3-.3A6.5 6.5 0 1 0 14 15.5l.3.3v.8l5 5 1.5-1.5-5-5zm-6 0a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"/></svg>
          חיפוש באזור זה
        </button>
      } @else if (areaActive) {
        <span class="nm__area-chip">
          מציג מודעות באזור המפה
          <button type="button" (click)="onClearArea()" aria-label="ביטול חיפוש לפי אזור">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>
          </button>
        </span>
      }
    </div>
  }

  <!-- Legend -->
  @if (!failed && !loading) {
    <div class="nm__legend" aria-hidden="true">
      <span><i class="dot dot--private"></i>פרטי</span>
      <span><i class="dot dot--business"></i>מתווך</span>
      <span><i class="dot dot--vip"></i>מקודם</span>
    </div>
  }

  @if (truncated && !loading) {
    <div class="nm__note">מוצגים {{ 3000 | number }} הנכסים האחרונים – הגדילו את התצוגה או צמצמו את החיפוש</div>
  }

  <!-- Preview card -->
  @if (selected) {
    <div class="nm__preview" role="dialog" aria-label="תצוגה מקדימה של המודעה">
      <button type="button" class="nm__preview-close" (click)="closePreview()" aria-label="סגירה">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>
      </button>
      @if (selected.loading) {
        <div class="nm__preview-loading"><span class="nm__spinner"></span> טוען…</div>
      } @else if (selected.product) {
        <a class="nm__preview-link" [routerLink]="['/single/' + selected.id]">
          <div class="nm__preview-img">
            @if (previewImage(selected.product)) {
              <img [src]="previewImage(selected.product)" [alt]="selected.product.name || ''" loading="lazy" />
            } @else {
              <span class="nm__preview-noimg">🏠</span>
            }
          </div>
          <div class="nm__preview-body">
            <div class="nm__preview-price">{{ previewPrice(selected.product) }}</div>
            <div class="nm__preview-meta">
              @if (selected.product.RoomsNum?.numberOfRooms) { <span>{{ selected.product.RoomsNum.numberOfRooms }} חד׳</span> }
              @if (selected.product.Floor != null) { <span>קומה {{ selected.product.Floor }}</span> }
              @if (selected.product.buildingMeterTotal) { <span>{{ selected.product.buildingMeterTotal }} מ״ר</span> }
            </div>
            @if (previewAddress(selected.product)) {
              <div class="nm__preview-addr">{{ previewAddress(selected.product) }}</div>
            }
            <span class="nm__preview-cta">לצפייה במודעה ←</span>
          </div>
        </a>
        <button type="button" class="nm__preview-save" (click)="saveSelected($event)" aria-label="שמירה למועדפים">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.1 18.6 12 18.7l-.1-.1C7.1 14.2 4 11.4 4 8.5 4 6.5 5.5 5 7.5 5c1.5 0 3 1 3.6 2.4h1.9C13.5 6 15 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.9-3.1 5.7-7.9 10.1zM16.5 3c-1.7 0-3.4.8-4.5 2.1C10.9 3.8 9.2 3 7.5 3 4.4 3 2 5.4 2 8.5c0 3.8 3.4 6.9 8.6 11.5L12 21.4l1.4-1.3C18.6 15.4 22 12.3 22 8.5 22 5.4 19.6 3 16.5 3z"/></svg>
        </button>
      } @else {
        <div class="nm__preview-loading">לא הצלחנו לטעון את המודעה</div>
      }
    </div>
  }

  <!-- Fallback -->
  @if (failed) {
    <div class="nm__failed" role="status">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 3l-.2.1L15 5.1 9 3 3.4 4.9c-.2.1-.4.3-.4.5V20.5c0 .3.2.5.5.5l.2-.1L9 18.9l6 2.1 5.6-1.9c.2-.1.4-.3.4-.5V3.5c0-.3-.2-.5-.5-.5zM15 19l-6-2.1V5l6 2.1V19z"/></svg>
      <strong>המפה לא זמינה כרגע</strong>
      <span>אפשר להמשיך לגלול ברשימת המודעות.</span>
    </div>
  }
</div>
